import { Injectable } from '@angular/core';
import {BaseFormProtectionService} from '@user/core/services/form-protection/base-form-protection.service';
import {StorageService} from '@user/core/services/storage.service';
import {ApiBase} from '@user/core/services/api.service';
import {CustomParameterService} from '@user/core/services/custom-parameter.service';

@Injectable({
  providedIn: 'root'
})
export class UrlFormProtectionService extends BaseFormProtectionService{
  queryKey = 'u';
  storeKey = 'url_code';
  baseUrl = '/url/check';
  parameterName = 'url';

  constructor(
    protected apiBase: ApiBase,
    protected storageService: StorageService,
    protected customParameterService: CustomParameterService,
  ) {
    super(apiBase, storageService, customParameterService);
  }
}
